import { Button, Flex, useMediaQuery } from "@chakra-ui/react"
import { useAtom } from "jotai"
import { useNavigate } from "react-router-dom"
import { Paths, mobileBreakpoint } from "../../common/commonConstants"
import { CreateNewFMP } from "../../pages/fmp/createNewFMPButton.main"
import { useIsLoggedIn } from "../commons/utils"
import { loginModalOpenAtom } from "../Menu/menu.store"

export const ProductActionButtons = (): JSX.Element => {
  const navigate = useNavigate()
  const isLoggedIn = useIsLoggedIn()
  const [isDesktop] = useMediaQuery(`(min-width: ${mobileBreakpoint}px)`)
  const [, setLoginModalOpen] = useAtom(loginModalOpenAtom)

  const handleFMPClick = (): void => {
    if (isLoggedIn) {
      navigate(Paths.FMP.MY_FMP)
    } else {
      setLoginModalOpen(true)
    }
  }

  return (
    <Flex flexDir="column" align="flex-start" gap="12px">
      <CreateNewFMP
        buttonText="Create A Fire Management Plan"
        buttonProps={{ variant: "Button1RegularAccentWithShadow", px: "18px", pt: "6px", onClick: handleFMPClick }}
      />
      <Button
        variant="Button1RegularWithShadow"
        px={["18px"]}
        fontSize={["12px", "16px", "16px", "16px", "16px"]}
        fontWeight="400"
        maxW={["109px", "109px", "109px", "179px"]}
        onClick={() => {
          navigate(isLoggedIn ? Paths.FMP.PRODUCT_FILTER : Paths.PRODUCT_FILTER)
        }}
      >
        {isDesktop ? "Use Product Filter" : "See More"}
      </Button>
      <Button
        variant={"Button1Regular"}
        onClick={() => {
          void navigate(Paths.DISTRIBUTORS)
        }}
      >
        Buy From Distributor
      </Button>
    </Flex>
  )
}
